import {UIIcon} from '@dropbox/dig-icons';
import {CheckmarkCircleFill, OpenLine} from '@dropbox/dig-icons/assets';
import type {AdminWorkstreamImporterCreatedWorkstream} from 'client';
import {Link} from 'components/DSYS/Link';
import {ROUTE_PATHS} from 'constant';

import styles from './AdminWorkstreamImporterCreatedStatus.module.css';

/** Status cell content for a row whose workstream was created by the import. */
export const AdminWorkstreamImporterCreatedStatus = ({
  workstream,
}: {
  workstream: AdminWorkstreamImporterCreatedWorkstream;
}) => (
  <Link
    to={ROUTE_PATHS.WORKSTREAMS_DETAIL.replace(':id', String(workstream.id))}
    openInNewTab
    aria-label={`Created ${workstream.name}. Open workstream in a new tab`}
    className={styles.link}
  >
    <UIIcon src={CheckmarkCircleFill} size="small" className={styles.createdIcon} />
    <UIIcon src={OpenLine} size="small" />
  </Link>
);
